import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {AccountModel} from "../../../account/angular/models/account.model";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CustomersAlerts} from "../../../customers/services/customers-alerts.service";
import {CustomersDialogService} from "../../../customers/services/customers-dialogs-service.service";
import {CustomersRequests} from "../../../customers/services/customers-requests.service";
import {CustomerService} from "../../../customers/services/customers-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";

export class advancedOrderTaskSpecFormCtrl implements IController {

  form: any;
  taskSpec: any;
  customer: any;
  accountId: any;
  account: AccountModel;
  addressZoneId: string;
  configZoneId: string;
  isCustomAddress: boolean;
  isAddressButtonEnabled: boolean;
  isDuplicate: boolean;
  depotIds: any;
  isShowProxyCheckbox: any;
  isShowMapPinBtn: boolean;
  useLegacyServiceTime: boolean;
  onClick: Function;
  onToggleCustom: Function;
  onCustomerChange: Function;
  onAddressChange: Function;

  public siteInfo: any;
  public locationTypes: typeof LocationType = LocationType;
  public accountIds: string[];
  private customerAddressId: any;
  public enableDisplayAllCustomers: boolean;


  /* @ngInject */
  constructor(private splitService, private customersDialogService: CustomersDialogService, private $log, private customersRequests: CustomersRequests, private bringozLoaderService: BringozLoaderService,
              private customersAlerts: CustomersAlerts, private $filter, private customerService: CustomerService, private siteContextService: SiteContextService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.locationTypes = LocationType;
    this.enableDisplayAllCustomers = this.splitService.getOmsOrderEnableDisplayAllCustomers();
  }

  $onInit() {
    this._initCustomerAddresId();
  };

  $onChanges(changes) {
    if (changes.customer && !changes.customer.isFirstChange()) {
      var customerCurrentValue = changes.customer.currentValue;
      this.customer = customerCurrentValue;

      if (customerCurrentValue) {
        this.onPhoneChange(_.get(customerCurrentValue, 'phone'));
        this.onAdditionalPhoneChange(_.get(customerCurrentValue, 'additionalPhone'));
      }

      this.customerAddressId = customerCurrentValue ? customerCurrentValue.defaultAddressId : undefined;

      if (!_.isUndefined(this.customerAddressId)) {
        this.onCustomerAddressIdSelect(this.customerAddressId);
      }
    }
    if (changes.accountId) {
      this.accountIds = this.accountId ? [this.accountId] : [];
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onLocationTypeChange(locationType: LocationType) {

    if (!this.taskSpec.locationDetails) {
      this.taskSpec.locationDetails = {}
    }

    if (!this.taskSpec.contact) {
      this.taskSpec.contact = {}
    }

    _.unset(this.taskSpec, 'locationDetails.id');

    this.taskSpec.locationDetails.locationType = locationType;

    //CUSTOMER
    // this.customer = undefined;
    _.unset(this.taskSpec, 'customerId');

    // CONTACT
    // _.unset(this.taskSpec.contact, 'name');
    // _.unset(this.taskSpec.contact, 'businessName');
    // _.unset(this.taskSpec.contact, 'phoneNo');
    // _.unset(this.taskSpec.contact, 'additionalPhoneNo');
    // _.unset(this.taskSpec.contact, 'email');
  }

  onAccountLocationSelect(account: AccountModel) {

    const isAccountChanged = !!this.taskSpec.locationDetails?.id && this.taskSpec.locationDetails.id !== account?.id;
    if (isAccountChanged || !this.taskSpec.extraInfo) {
      this.taskSpec.extraInfo = account?.note;
    }

    this.taskSpec.locationDetails.id = _.get(account, 'id');
    this.taskSpec.contact.businessName = _.get(account, 'name');
    this.taskSpec.contact.name = _.get(account, 'name');
    this.taskSpec.contact.phoneNo = _.get(account, 'phoneNumber');
    this.taskSpec.contact.additionalPhoneNo = _.get(account, 'additionalPhoneNo');

    this.changeAddress(_.get(account, 'address'));
  }

  onDepotLocationSelect(depot) {
    this.taskSpec.locationDetails.id = _.get(depot, 'id');
    this.taskSpec.contact.businessName = _.get(depot, 'name');
    this.taskSpec.contact.name = _.get(depot, 'contactName');
    this.taskSpec.contact.phoneNo = _.get(depot, 'phoneNumber')
    this.taskSpec.contact.additionalPhoneNo = _.get(depot, 'additionalPhoneNo');

    this.changeAddress(_.get(depot, 'address'));
  }

  onCustomerLocationSelect(customer) {
    this.taskSpec.locationDetails.id = _.get(customer, 'id');
    this.taskSpec.customerId = _.get(customer, 'id');
    this.taskSpec.contact.name = this._getCustomerName(customer);
    this.taskSpec.contact.businessName = _.get(customer, 'businessName');
    this.taskSpec.contact.phoneNo = _.get(customer, 'phone');
    this.taskSpec.contact.additionalPhoneNo = _.get(customer, 'additionalPhone');
    this.taskSpec.contact.email = _.get(customer, 'email');

    const address = _.find(customer.addresses, (a) => {
      return a.id === customer.defaultAddressId;
    })
    if (address) {
      this.changeAddress(address);
    }
    this.onCustomerChange({customer: customer});
  }

  changeAddress(address) {
    this.taskSpec.address = address;
    this.onAddressChange({address: address});
  }

  onPhoneChange(phone) {
    this.taskSpec.contact.phoneNo = phone;
  }

  onAdditionalPhoneChange(additionalPhoneNo) {
    this.taskSpec.contact.additionalPhoneNo = additionalPhoneNo;
  }

  _getCustomerName(customer) {
    if (!customer) {
      return undefined;
    }
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  onCustomerAddressIdSelect(addressId) {
    this.customerAddressId = addressId;

    if (addressId) {
      const address = angular.copy(_.find(this.customer.addresses, (a) => {
        return a.id === addressId;
      }));
      if (address) {
        this.changeAddress(address)
      }
    }
  }

  onCreateCustomer(customer, event) {
    this.customersDialogService.createCustomer(event, customer)
      .then((customerToCreate) => {
        this._createCustomer(customerToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCustomer(event) {
    this.customersDialogService.editCustomer(event, this.customer)
      .then((customerToUpdate) => {
        this._updateCustomer(customerToUpdate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onCreateCustomerAddress(event) {
    this.customersDialogService.addAddress(event)
      .then((address) => {
        this._createCustomerAddress(address);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onEditCustomerAddress(customerAddressId, event) {
    const address = _.find(this.customer.addresses, (address) => {
      return address.id === customerAddressId;
    });

    const originalAddress = angular.copy(address);

    this.customersDialogService.editAddress(address, event)
      .then((editedAddress) => {
        this._updateCustomerAddress(editedAddress, address.id, originalAddress)
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onChangeServiceTime(serviceTime) {
    this.taskSpec.serviceTime = serviceTime;
  }

  onChangeDetailedTimeValue(serviceTimeType, value) {
    this.taskSpec.detailedServiceTime[serviceTimeType] = value;
  }

  // ******************************
  //        Private methods
  // ******************************

  _createCustomer(customer) {
    this.customerService.createCustomer(customer)
      .then((createdCustomer) => {
        // this.onSelectCustomer(createdCustomer);
        this.onCustomerLocationSelect(createdCustomer);
      })
  }

  _updateCustomer(customer) {
    this.bringozLoaderService.on();
    this.customersRequests.updateCustomer(customer.id, customer)
      .then((updatedCustomer) => {
        // this.onSelectCustomer(updatedCustomer);
        this.onCustomerLocationSelect(updatedCustomer);
        this.customersAlerts.updateSuccess();
      })
      .catch((error) => {
        this.customersAlerts.updateError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _createCustomerAddress(address) {
    this.bringozLoaderService.on();
    this.customersRequests.addAddress(this.customer.id, address)
      .then((createdAddress) => {
        this.customer.addresses.push(createdAddress);
        this.changeAddress(createdAddress);
        this.customerAddressId = createdAddress.id;
        this.customersAlerts.addAddressSuccess();
      })
      .catch((error) => {
        this.customersAlerts.addAddressError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  _updateCustomerAddress(address, addressId, originalAddress) {
    this.bringozLoaderService.on();
    this.customersRequests.updateAddress(this.customer.id, addressId, address)
      .then((updatedAddress) => {
        this.customer.addresses = _.chain(this.customer.addresses)
          .filter((a) => {
            return a.id !== addressId;
          })
          .concat([updatedAddress])
          .value();

        this.changeAddress(updatedAddress);

        this.customersAlerts.updateAddressSuccess(originalAddress);
      })
      .catch((error) => {
        this.customersAlerts.updateAddressError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _initCustomerAddresId() {
    if (this.customer) {
      const selectedAddress = _.find(this.customer.addresses, (a) => {
        if (!a.location) {
          return false;
        }
        return a.location.lat === _.get(this.taskSpec, 'address.location.lat') &&
          a.location.lng === _.get(this.taskSpec, 'address.location.lng')
      });

      if (selectedAddress) {
        this.customerAddressId = selectedAddress.id;
        this.onCustomerAddressIdSelect(selectedAddress.id);
      } else {
        // ctrl.customer.addresses.push(ctrl.taskSpec.address);
        const addressToAdd = angular.copy(this.taskSpec.address);
        addressToAdd.id = addressToAdd.placeId;
        this.customer.addresses = this.customer.addresses.concat([addressToAdd]);
        this.customerAddressId = addressToAdd.placeId;
      }

    } else {
      this.customerAddressId = undefined;
    }
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('advancedOrderTaskSpecForm', {
    require: {
      form: '^form'
    },
    bindings: {
      taskSpec: '<',
      customer: '<',
      accountId: '<?',
      account: '<?',
      addressZoneId: '<',
      configZoneId: '<',
      isCustomAddress: '<',
      isAddressButtonEnabled: '<',
      isDuplicate: '<',
      depotIds: '<',
      isShowMapPinBtn: '<?',
      isShowProxyCheckbox: '<',
      useLegacyServiceTime: '<?',
      onClick: '&',
      onToggleCustom: '&',
      onCustomerChange: '&',
      onAddressChange: '&'
    },
    template: require('./advanced-order-task-spec-form.html').default,
    controller: advancedOrderTaskSpecFormCtrl
  });
